/* eslint-disable */
import React, { useState } from "react";
import "../styles/CircularCarousel.css";
import champagne from "../assets/servicios/champagne.png";
import restaurante from "../assets/servicios/restaurante.jpg";
import playa from "../assets/servicios/playa.jpg";
import cena from "../assets/servicios/cena.jpg";
import exp from "../assets/servicios/exp.png";
import { useTranslation } from 'react-i18next';

export default function CircularCarousel() {

  const { t } = useTranslation();

  const servicios = [
  {
    key: "champagne",
    titulo: t("servicios.champagne.titulo"),
    descripcion: t("servicios.champagne.descripcion"),
    imagen: champagne,
  },
  {
    key: "restaurantes",
    titulo: t("servicios.restaurantes.titulo"),
    descripcion: t("servicios.restaurantes.descripcion"),
    imagen: restaurante,
  },
  {
    key: "playa",
    titulo: t("servicios.playa.titulo"),
    descripcion: t("servicios.playa.descripcion"),
    imagen: playa,
  },
  {
    key: "cena",
    titulo: t("servicios.cena.titulo"),
    descripcion: t("servicios.cena.descripcion"),
    imagen: cena,
  },
  {
    key: "sensorial",
    titulo: t("servicios.sensorial.titulo"),
    descripcion: t("servicios.sensorial.descripcion"),
    imagen: exp,
  },
];
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [rotation, setRotation] = useState(0); // 👈 acumulamos rotación

  const total = servicios.length;

  const itemWidth = 360;
  const theta = 360 / total;
  const radius = Math.round(itemWidth / 2 / Math.tan(Math.PI / total)) + 100;

  const handleNext = () => {
    setSelectedIndex((prev) => (prev + 1) % total);
    setRotation((prev) => prev - theta); // 👈 girar hacia adelante
  };

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev - 1 + total) % total);
    setRotation((prev) => prev + theta); // 👈 girar hacia atrás
  };

  const containerStyle = {
    transform: `translateZ(-${radius}px) rotateY(${rotation}deg)`,
  };

  return (
    <div className="carousel-3d-wrapper">
      <div className="carousel-3d-scene">
        <div className="carousel-3d-container" style={containerStyle}>
          {servicios.map((item, index) => {
            const angle = theta * index;
            const isActive = index === selectedIndex;

            return (
              <div
                key={index}
                className="carousel-3d-slide"
                style={{
                  transform: `rotateY(${angle}deg) translateZ(${radius}px)`,
                }}
              >
                <img src={item.imagen} alt={item.titulo} />
                <div className={`card-hover ${isActive ? "visible" : ""}`}>
                  <h3>{item.titulo}</h3>
                  <p>{item.descripcion}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="controls">
        <button onClick={handlePrev}>‹</button>
        <button onClick={handleNext}>›</button>
      </div>
    </div>
  );
}
